import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import componentStyles from './Disclaimer.styles.esm.js';
import { cn } from '../../utils/cn.esm.js';

/**
 * Disclaimer component for displaying legal disclaimers, terms, and fine print text.
 * Built with design tokens for consistent typography and color theming.
 *
 * @component
 * @example
 * ```tsx
 * <Disclaimer>
 *   *Terms and conditions apply. See website for details.
 * </Disclaimer>
 *
 * <Disclaimer inverse>
 *   This offer expires December 31, 2024.
 * </Disclaimer>
 * ```
 */
const Disclaimer = React__default.forwardRef((_a, ref) => {
    var { className, inverse = false, children } = _a, otherProps = __rest(_a, ["className", "inverse", "children"]);
    // Generate the class names based on the variants
    const { base: baseClasses, leading: leadingClasses } = componentStyles({
        inverse,
    });
    const finalClasses = cn(baseClasses(), leadingClasses(), className);
    // Render the disclaimer component
    return (jsx("p", Object.assign({ ref: ref, className: finalClasses }, otherProps, { children: children })));
});
Disclaimer.displayName = "Disclaimer";

export { Disclaimer };
